import React from "react";
import { Clock } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

const URGENCY_CONFIG = {
  ok:     { bg: "bg-blue-50",    border: "border-blue-100",   text: "text-blue-700",   icon: "text-blue-400"   },
  soon:   { bg: "bg-amber-50",   border: "border-amber-100",  text: "text-amber-700",  icon: "text-amber-400"  },
  now:    { bg: "bg-red-50",     border: "border-red-100",    text: "text-red-700",    icon: "text-red-400"    },
  passed: { bg: "bg-red-100",    border: "border-red-200",    text: "text-red-800",    icon: "text-red-500"    },
};

export function BoardingCountdown({ countdown }) {
  if (!countdown) return null;
  const cfg = URGENCY_CONFIG[countdown.urgency] || URGENCY_CONFIG.ok;

  return (
    <div
      className={`flex items-start gap-2.5 border p-3 rounded-sm ${cfg.bg} ${cfg.border}`}
      data-testid="boarding-countdown"
    >
      <Clock size={14} strokeWidth={1.5} className={`${cfg.icon} flex-shrink-0 mt-0.5`} />
      <p className={`text-sm leading-relaxed ${cfg.text}`} style={LORA}>
        {countdown.message}
      </p>
    </div>
  );
}
